import { BACKEND_URL, signedApiClient, signedHeaders } from './apiClient';

class MetricsService {

  async recordEntryMetrics(payload: {
    entryId: string;
    sessionId: string;
    studyId: string;
    formId: string;
    event: string;
    timestamp: number;
    entryToken?: string;
    caseId?: string;
  }) {
    const uri = `metrics`;
    const apiClient = signedApiClient('POST', uri);
    return await apiClient.post(uri, payload);
  }

  recordEntryMetricsWithKeepAlive(payload: {
    entryId: string;
    sessionId: string;
    studyId: string;
    formId: string;
    event: string;
    timestamp: number;
    entryToken?: string;
    caseId?: string;
  }) {
    // `keepalive` is the whole point of this variant — it is sent while the page is unloading, and
    // axios has no equivalent. So this one builds the signature itself rather than going through a
    // signed client.
    const uri = `metrics`;
    const url = `${BACKEND_URL}/${uri}`;

    const headers: Record<string, string> = {
      'Content-Type': 'application/json',
      ...signedHeaders('POST', uri)
    };

    fetch(url, {
      method: 'POST',
      headers: headers,
      body: JSON.stringify(payload),
      keepalive: true
    }).catch(() => {});
  }
}

export default new MetricsService();
